import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from '../utils/api';
import { storeAuthRole } from '../utils/auth';

const getResponseErrorMessage = async (response, fallbackMessage) => {
  const responseText = await response.text().catch(() => '');

  if (responseText) {
    if (/^\s*<!doctype html/i.test(responseText) || /^\s*<html[\s>]/i.test(responseText)) {
      return 'Authentication service is temporarily unavailable. Please try again in a few minutes.';
    }

    try {
      const data = JSON.parse(responseText);
      return data?.error || data?.message || data?.error_description || fallbackMessage;
    } catch {
      return responseText;
    }
  }

  return fallbackMessage;
};

function Callback() {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const hasAttemptedRef = useRef(false);

  useEffect(() => {
    const run = async () => {
      
      if (hasAttemptedRef.current) return;
      hasAttemptedRef.current = true;

      // Support code in either query string or hash fragment query.
      const params = new URLSearchParams(window.location.search);
      let code = params.get('code');

      if (!code && window.location.hash.includes('?')) {
        const hashQuery = window.location.hash.split('?')[1] || '';
        code = new URLSearchParams(hashQuery).get('code');
      }

      if (!code) {
        setError('No authorization code received.');
        return;
      }

      // Exchange the code with the backend. Provider tokens stay server-side.
      fetch(`${API_BASE}/auth/token`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          code
        }).toString()
      })
      .then(async (res) => {
        if (!res.ok) {
          throw new Error(await getResponseErrorMessage(
            res,
            `HTTP ${res.status}: ${res.statusText || 'Token endpoint failed'}`
          ));
        }
        return res.json();
      })
      .then(async (data) => {
        if (data.authenticated) {
          localStorage.setItem('authSession', 'true');
          if (data.user) {
            localStorage.setItem('authUser', JSON.stringify(data.user));
          }
          if (data.dhtUser) {
            localStorage.setItem('dhtUser', JSON.stringify(data.dhtUser));
          }
          storeAuthRole(data.role || 'user');
          navigate('/org-role-select');
        } else {
          setError(data.error_description || data.error || 'Token exchange failed.');
        }
      })
      .catch((err) => {
        console.error('Token exchange error:', err);
        setError(`Token exchange failed: ${err.message}`);
      });
    };

    run();
  }, [navigate]);

  return (
    <div className="login-container">
      <div className="login-card">
        <h1 className="login-title">Drone Hotel</h1>
        {error ? (
          <div className="alert alert-danger">{error}</div>
        ) : (
          <p style={{ textAlign: 'center', color: '#666' }}>Logging you in...</p>
        )}
      </div>
    </div>
  );
}

export default Callback;
